const ls = require("lightstreamer-client-web");
import lsClient from "./client";
/* global Button, console, Excel, Header, HeroList, HeroListItem, Progress */

export const getSubscription = (subscriptionMode, instrument, columns) => {
  const client = lsClient();
  // Create the subscription. subscriptionMode should be "MERGE"
  const subscription = new ls.Subscription(subscriptionMode, instrument, columns);
  client.subscribe(subscription);
  return subscription;
};

export const unsubscribe = (subscription) => {
  const client = lsClient();

  client.unsubscribe(subscription);
};
